import { HttpClient } from '@opallabs/api'
import addWorkflowToContent from '../addWorkflowToContent'
import loadWorkflow from '../loadWorkflow'
import setLoader from '../setLoader'

const putWorkflow = ({ type, identifier }) =>
  HttpClient().put(
    `/api/v1/${
      type && identifier ? `${type}/${identifier}/` : ''
    }workflow/start`,
    {}
  )

const startWorkflow =
  ({ identifier, onStartWorkflow, type }) =>
  (dispatch) => {
    putWorkflow({ type, identifier })
      .then((response) => {
        if (onStartWorkflow) {
          onStartWorkflow()
        }
        dispatch(setLoader({ startingWorkflow: false }))
        dispatch(addWorkflowToContent(response.data))
        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default startWorkflow
